import React, { Fragment, Component } from "react";
import Slider from "react-slick";
import conference from "../../../assets/utils/images/top-img.png";
import live_call from "../../../assets/utils/images/live-calls.png";
import video_api from "../../../assets/utils/images/video-api.png";
import video_kiosk from "../../../assets/utils/images/video-kiosk.png";
import { withRouter } from "react-router";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { auth, recaptchaVerifier, signInWithGoogle } from "../../../Auth/Firebase";
import { isAuthenticated } from "../../../States/Token";
import { config } from "../../../config";
import { get_landing_page } from "../../../Helpers/Router";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      message: "",
      disable_input: false,
      show_password: false,
    };
    this.recaptchaVerifier = null;

    this.signInWithEmailAndPasswordHandler =
      this.signInWithEmailAndPasswordHandler.bind(this);
  }

  componentDidMount() {
    if (isAuthenticated()) {
      // this.props.history.push(get_landing_page());
    }
    this.recaptchaVerifier = new recaptchaVerifier("login_to_dashboard", {
      size: "invisible",
      callback: (response) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        // console.log("SUCCESSFULL SIGNIN");
      },
    });
  }

  signInWithEmailAndPasswordHandler = (email, password) => {
    this.setState({ message: "" });
    if (!email.trim()) {
      this.setState({ message: "Email cannot be empty." });
      return;
    }
    if (!password.trim()) {
      this.setState({ message: "Password cannot be empty." });
      return;
    }
    this.setState({ disable_input: true });
    this.recaptchaVerifier.verify().then(() => {
      auth
        .signInWithEmailAndPassword(email, password)
        .then((response) => {
          // this.props.history.push(get_landing_page());
          this.setState({ disable_input: false });
        })
        .catch((error) => {
          this.setState({ message: error.message });
          this.setState({ disable_input: false });
        });
    }).catch((error) => {
      this.setState({ message: error.message });
      this.setState({ disable_input: false });
    });
  };

  handleEnterPress = (event, callback) => {
    if (event.key === 'Enter') {
      callback();
    }
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    // Detect if the page is running inside an iframe
    const isInIframe = window.self !== window.top;

    return (

      <Fragment>
        <div className="login-main">
          {isInIframe ? (

<div
  style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
    color: "#333",
    fontFamily: "'Helvetica Neue', sans-serif",
    padding: "20px",
    margin: "auto",
  }}
>
  <FontAwesomeIcon
    icon={faExclamationTriangle} 
    style={{
      fontSize: "3rem", 
      color: "#FF6B6B", 
      marginBottom: "20px",
    }} 
  />
  <h1 style={{
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#4A90E2",
    marginBottom: "10px",
  }}>
    Token Expired
  </h1>
  <h2 style={{
    fontSize: "1.5rem",
    fontWeight: "400",
    color: "#666",
    marginBottom: "30px",
  }}>
    Please log in again to continue
  </h2>
</div>

          ) : (
            <div className="login-video">
              <video
                autoPlay
                loop
                muted
                className="sample-video h-100 no-gutters"
              >
                <source
                  src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/hb-opt.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
          {isInIframe ? (
            <><div className="login-form" style={{ display: "none" }}>
              <Row className="h-100 no-gutters">
                <Col
                  lg="12"
                  md="12"
                  className="h-100 d-flex bg-white justify-content-center align-items-center"
                >
                  <Col lg="9" md="10" sm="12" className="mx-auto app-login-box" style={{ textAlign: "center" }}>
                    {/* <div className="app-block-logo" /> */}
                    <div>
                      <img
                        src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/sa-new-Logo.png"
                        alt="SaleAssist Logo"
                        style={{ width: "200px", marginRight: "auto" }}
                      />
                    </div>
                    <Row className="divider" />
                    <h5>LOGIN</h5>
                    <div style={{
                      color: "grey",
                      backgroundColor: "white",
                      border: "none",
                      borderRadius: "0.25rem",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",  // Adds a subtle shadow for the card effect
                      padding: "10px 15px",  // Adds some padding to make it feel more like a card
                      backgroundSize: "70%",
                    }}>
                      <div className="block">
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            signInWithGoogle();
                          }}
                          className="google-login-button"
                          style={{ width: "200px" }}
                        ></Button>

                        <Button

                          onClick={(e) => {
                            e.preventDefault();
                            this.props.history.push("/auth/phone_login");
                          }}
                          style={{
                            color: "grey",
                            backgroundColor: "white",
                            height: "40px",
                            border: "none",
                            borderRadius: "0.25rem",
                            boxShadow: "0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25)",  // Adds a subtle shadow for the card effect
                            padding: "0px 15px",  // Adds some padding to make it feel more like a card
                            backgroundSize: "contain",
                          }}
                        >
                          <i className="fas fa-th mr-2"></i>
                          Sign in with Mobile number
                        </Button>
                      </div>



                      <div className="divider-container">
                        <div className="divider-line"></div>
                        <span className="divider-text">Or</span>
                        <div className="divider-line"></div>
                      </div>
                      <h6 className="mt-3 text-danger">{this.state.message}</h6>
                      <div>
                        {/* <Form onSubmit={(e) => e.preventDefault()}> */}
                        <Row form>
                          <Col md={12}>
                            <FormGroup style={{ textAlign: "left" }}>
                              <Label for="exampleEmail">Email</Label>
                              <Input
                                type="email"
                                name="email"
                                id="exampleEmail"
                                placeholder="Email here..."
                                onChange={(e) => {
                                  this.setState({ email: e.target.value });
                                }}
                                value={this.state.email}
                                disabled={this.state.disable_input}
                                onKeyPress={(e) => this.handleEnterPress(e, () => { this.signInWithEmailAndPasswordHandler(this.state.email, this.state.password) })}
                              />
                            </FormGroup >
                          </Col>
                          <Col md={12}>
                          <FormGroup style={{ textAlign: "left", position: "relative" }}>
                              <Label for="examplePassword">Password</Label>
                              <Input
                                type={!this.state.show_password ? "password" : "text"}
                                name="password"
                                id="examplePassword"
                                placeholder="Password here..."
                                onChange={(e) => {
                                  this.setState({ password: e.target.value });
                                }}
                                value={this.state.password}
                                disabled={this.state.disable_input}
                                onKeyPress={(e) => this.handleEnterPress(e, () => { this.signInWithEmailAndPasswordHandler(this.state.email, this.state.password) })}
                              />
                              {this.state.show_password ? 
                              <FaRegEye onClick={() => this.setState({show_password: !this.state.show_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                              : <FaEyeSlash onClick={() => this.setState({show_password: !this.state.show_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                              }
                            </FormGroup>
                          </Col>
                        </Row>
                        {/* <FormGroup check>
                             <Input type="checkbox" name="check" id="exampleCheck" />
                             <Label for="exampleCheck" check>
                               Keep me logged in
                             </Label>
                           </FormGroup> */}
                        <Row className="divider" />
                        <div className="d-flex align-items-center" style={{ textAlign: "center" }}>
                          <div className="ml-auto">
                            <a
                              href="#"
                              className="btn-lg btn btn-link"
                              onClick={(e) => {
                                e.preventDefault();
                                this.props.history.push("/auth/forgot_password");
                              }}
                            >
                              Forgot Password
                            </a>
                            {" "}
                            <Button
                              className="login-btn btn-hover-shine"
                              id="login_to_dashboard"
                              color="primary"
                              size="lg"
                              onClick={(e) => {
                                e.preventDefault();
                                this.signInWithEmailAndPasswordHandler(
                                  this.state.email,
                                  this.state.password
                                );
                              }}
                              disabled={this.state.disable_input}
                            >
                              Sign In
                            </Button>

                          </div>

                        </div>
                        {/* </Form> */}
                        <h6 className="mt-3" style={{ alignItems: "center" }}>
                          Need an account?{" "}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/auth/register");
                            }}
                            style={{ fontSize: "13px", fontWeight: "bolder", color: "black" }}
                          >
                            SIGN UP
                            <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                          </a>
                        </h6>
                      </div>
                    </div>

                  </Col>
                </Col>
              </Row>
            </div></>
          ) : (
            <div className="login-form">
              <Row className="h-100 no-gutters">
                <Col
                  lg="12"
                  md="12"
                  className="h-100 d-flex bg-white justify-content-center align-items-center"
                >
                  <Col lg="9" md="10" sm="12" className="mx-auto app-login-box" style={{ textAlign: "center" }}>
                    {/* <div className="app-block-logo" /> */}
                    {isInIframe ? (
                      <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        textAlign: "center",
                      }}>
                        <h4>Token expired, please login again</h4>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/sa-new-Logo.png"
                          alt="SaleAssist Logo"
                          style={{ width: "200px", marginRight: "auto" }}
                        />
                      </div>
                    )}
                    <Row className="divider" />
                    <h5>LOGIN</h5>
                    <div style={{
                      color: "grey",
                      backgroundColor: "white",
                      border: "none",
                      borderRadius: "0.25rem",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",  // Adds a subtle shadow for the card effect
                      padding: "10px 15px",  // Adds some padding to make it feel more like a card
                      backgroundSize: "70%",
                    }}>
                      <div className="block">
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            signInWithGoogle();
                          }}
                          className="google-login-button"
                          style={{ width: "200px" }}
                        ></Button>

                        <Button

                          onClick={(e) => {
                            e.preventDefault();
                            this.props.history.push("/auth/phone_login");
                          }}
                          style={{
                            color: "grey",
                            backgroundColor: "white",
                            height: "40px",
                            border: "none",
                            borderRadius: "0.25rem",
                            boxShadow: "0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25)",  // Adds a subtle shadow for the card effect
                            padding: "0px 15px",  // Adds some padding to make it feel more like a card
                            backgroundSize: "contain",
                          }}
                        >
                          <i className="fas fa-th mr-2"></i>
                          Sign in with Mobile number
                        </Button>
                      </div>



                      <div className="divider-container">
                        <div className="divider-line"></div>
                        <span className="divider-text">Or</span>
                        <div className="divider-line"></div>
                      </div>
                      <h6 className="mt-3 text-danger">{this.state.message}</h6>
                      <div>
                        {/* <Form onSubmit={(e) => e.preventDefault()}> */}
                        <Row form>
                          <Col md={12}>
                            <FormGroup style={{ textAlign: "left" }}>
                              <Label for="exampleEmail">Email</Label>
                              <Input
                                type="email"
                                name="email"
                                id="exampleEmail"
                                placeholder="Email here..."
                                onChange={(e) => {
                                  this.setState({ email: e.target.value });
                                }}
                                value={this.state.email}
                                disabled={this.state.disable_input}
                                onKeyPress={(e) => this.handleEnterPress(e, () => { this.signInWithEmailAndPasswordHandler(this.state.email, this.state.password) })}
                              />
                            </FormGroup >
                          </Col>
                          <Col md={12}>
                            <FormGroup style={{ textAlign: "left", position: "relative" }}>
                              <Label for="examplePassword">Password</Label>
                              <Input
                                type={!this.state.show_password ? "password" : "text"}
                                name="password"
                                id="examplePassword"
                                placeholder="Password here..."
                                onChange={(e) => {
                                  this.setState({ password: e.target.value });
                                }}
                                value={this.state.password}
                                disabled={this.state.disable_input}
                                onKeyPress={(e) => this.handleEnterPress(e, () => { this.signInWithEmailAndPasswordHandler(this.state.email, this.state.password) })}
                              />
                              {this.state.show_password ? 
                              <FaRegEye onClick={() => this.setState({show_password: !this.state.show_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                              : <FaEyeSlash onClick={() => this.setState({show_password: !this.state.show_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                              }
                            </FormGroup>
                          </Col>
                        </Row>
                        {/* <FormGroup check>
                      <Input type="checkbox" name="check" id="exampleCheck" />
                      <Label for="exampleCheck" check>
                        Keep me logged in
                      </Label>
                    </FormGroup> */}
                        <Row className="divider" />
                        <div className="d-flex align-items-center" style={{ textAlign: "center" }}>
                          <div className="ml-auto">
                            <a
                              href="#"
                              className="btn-lg btn btn-link"
                              onClick={(e) => {
                                e.preventDefault();
                                this.props.history.push("/auth/forgot_password");
                              }}
                            >
                              Forgot Password
                            </a>
                            {" "}
                            <Button
                              className="login-btn btn-hover-shine"
                              id="login_to_dashboard"
                              color="primary"
                              size="lg"
                              onClick={(e) => {
                                e.preventDefault();
                                this.signInWithEmailAndPasswordHandler(
                                  this.state.email,
                                  this.state.password
                                );
                              }}
                              disabled={this.state.disable_input}
                            >
                              Sign In
                            </Button>

                          </div>

                        </div>
                        {/* </Form> */}
                        <h6 className="mt-3" style={{ alignItems: "center" }}>
                          Need an account?{" "}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.history.push("/auth/register");
                            }}
                            style={{ fontSize: "13px", fontWeight: "bolder", color: "black" }}
                          >
                            SIGN UP
                            <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                          </a>
                        </h6>
                      </div>
                    </div>

                  </Col>
                </Col>
              </Row>
            </div>
          )}
        </div>

      </Fragment>
    );
  }
}

export default withRouter(Login);
